module.exports = __webpack_public_path__ + "img/DB4-1920_08.cec61129.jpg";